import { createTheme } from "@mui/material/styles";
import { theme } from "@piiqtechnologies/ui-components";
const customTheme = createTheme(theme, {
    typography: {
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Helvetica Neue', sans-serif",
        // Headline figures (the Market Performance card's score); the shared scale tops out at h1's 28px.
        display: {
            fontStyle: "normal",
            fontWeight: 300,
            fontSize: 52,
            lineHeight: 1,
        },
    },
});
export default customTheme;
